// 受付証跡（写真・PDF）を Storage バケット request-evidence へ。OCRはしない。
import { supabase } from '../supabase.js'
import { isEvidenceFile, evidenceStoragePath, explainEvidenceError } from './intakeCore.js'

export const EVIDENCE_ACCEPT = 'image/*,.pdf,.heic,.heif'
export const EVIDENCE_MAX = 25 * 1024 * 1024

export function sanitizeEvidenceFilename(name) {
  return String(name || 'file').replace(/[^\w.\-()\u3000-\u9fff]/g, '_').slice(0, 80) || 'file'
}

export async function uploadEvidenceFiles(reqId, files) {
  if (!supabase) throw new Error('接続できません')
  if (!reqId) throw new Error('先に受付を保存してください')
  const list = Array.from(files || [])
  const out = []
  for (let i = 0; i < list.length; i++) {
    const f = list[i]
    if (!f) continue
    if (f.size > EVIDENCE_MAX) throw new Error('ファイルが大きすぎます（25MBまで）')
    if (!isEvidenceFile(f.name, f.type)) throw new Error('写真またはPDFのみ添付できます')
    const path = evidenceStoragePath(reqId, i, f.name)
    const type = f.type || (/\.pdf$/i.test(f.name) ? 'application/pdf' : 'application/octet-stream')
    const { error } = await supabase.storage.from('request-evidence').upload(path, f, {
      contentType: type,
      upsert: true,
    })
    if (error) throw new Error(explainEvidenceError(error))
    out.push({ filename: f.name || sanitizeEvidenceFilename(f.name), contentType: type, path })
  }
  return out
}
